import { Map, Record } from 'immutable';

export const key = 'object';

export type InstanceType = {
  inProgress: boolean;
  object: Map<string, any>;
  fieldsErrors: Map<string, boolean>;
  fieldsSucceeded: Map<string, boolean>;
  objectId: string | number;
  requestParams: { [k: string]: string };
  filters: { [k: string]: any };
  error: boolean;
};

export type InstanceStoreRecordType = Record<InstanceType>;
export const instanceStoreRecord: Record.Factory<any> = Record({
  inProgress: false,
  object: Map<string, any>(),
  fieldsErrors: Map<string, boolean>(),
  fieldsSucceeded: Map<string, boolean>(),
  objectId: null,
  requestParams: null,
  filters: null,
  error: false
});

type ObjectStoreType = {
  instances: Map<string, InstanceStoreRecordType>;
};

export type ObjectStoreRecordType = Record<ObjectStoreType>;

export type GlobalStore = {
  [key]: ObjectStoreRecordType;
};

const stateRecord: Record.Factory<ObjectStoreType> = Record({
  instances: Map<string, InstanceStoreRecordType>(),
});

export const initialState = stateRecord();
